import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { TranslatableKey } from '@app/types/translatable.type';
import {
    ANNUALLY,
    MonthlyIntervals,
    MonthsForDropdown,
    TimeOffDateFormatDashes,
} from '@time-off-v3/meta/time-off-meta';
import moment from 'moment';

type employeeHireDate = 'employeeHireDate';

@Component({
    selector: 'app-annual-fields',
    templateUrl: './annual-fields.template.html',
    styleUrls: ['./annual-fields.style.scss'],
})
export class AnnualFieldsComponent implements OnInit, OnDestroy {
    @Input() timeOffPolicy: TimeOffPolicy;
    @Input() containerClass = 'app-grid';
    @Input() fieldClass = 'columns-5 small-columns-12';
    @Input() firstDayOfPeriodLabel: TranslatableKey = 'time-off-v3.firstDayOfPeriod';

    @Output() requestPreviewParams: EventEmitter<string> = new EventEmitter();

    months: { label: string; value: number | employeeHireDate }[] = MonthsForDropdown.slice();
    daysPerMonth = MonthlyIntervals;
    selectedMonth: number | string;
    employeeHireDate: employeeHireDate = 'employeeHireDate';

    ngOnInit(): void {
        let selectedMonth = null;

        if (this.timeOffPolicy.dayOfYearOne) {
            selectedMonth = moment(this.timeOffPolicy.dayOfYearOne, TimeOffDateFormatDashes).month();
        }

        this.selectedMonth = this.timeOffPolicy.accrualFromHireDate ? this.employeeHireDate : selectedMonth;
    }

    getMonth(): number | string {
        if (this.timeOffPolicy.accrualFromHireDate && this.selectedMonth === this.employeeHireDate) {
            return this.employeeHireDate;
        }

        return moment(this.timeOffPolicy.dayOfYearOne, TimeOffDateFormatDashes).month();
    }

    getDay(): number {
        return moment(this.timeOffPolicy.dayOfYearOne, TimeOffDateFormatDashes).date();
    }

    setAnnualModelValuesWithDate(day: number): void {
        this.timeOffPolicy.dayOfYearOne = moment().date(day).month(this.selectedMonth).format(TimeOffDateFormatDashes);
    }

    // Only gets called for the purpose of setting accruals from the employee date
    setAnnualModelValuesWithoutDate(selectedMonth: number | string): void {
        /*
         * The user has selected 'employee hire date' for accruals if the value is -1,
         * no need to parse the full date.
         */
        this.timeOffPolicy.accrualFromHireDate = selectedMonth === this.employeeHireDate;
        this.timeOffPolicy.dayOfYearOne = undefined;
    }

    previewDataChanged(): void {
        this.requestPreviewParams.emit(ANNUALLY);
    }

    ngOnDestroy(): void {
        this.timeOffPolicy.resetDateValues(this.timeOffPolicy);
    }
}
